import '../scss/index.scss';

import {
  DataStorage,
  SpinnerOverlay
} from 'application/src/js/util.js';
import ProductOverview from './index/product-overview.js';

document.addEventListener('DOMContentLoaded', e => {
  new ProductOverview({
    loader: new SpinnerOverlay({
      element: document.querySelector('#loading-overlay')
    }),
    store: new DataStorage()
  });
});